module.exports = __webpack_public_path__ + "img/convert-3d-cube.844316c8.svg";